import { createAction } from 'redux-actions';
import * as ActionTypes from '../actionTypes/mesh';

export const getMeshList = createAction(ActionTypes.GET_MESH_LIST);
export const addMesh = createAction(ActionTypes.ADD_MESH);
